/**
 * User-facing MFA / shared-login deadline shown in the UI.
 * Backend enforcement (`MFA_ENFORCE_AFTER`) may be later (e.g. Sep 15) for safety.
 */
export const MFA_USER_FACING_DEADLINE = 'September 10, 2026';

/**
 * After this date the shared-login migration notice must no longer be shown —
 * the deadline has passed and old shared logins have stopped working.
 * Using midnight UTC on Sep 11 so the modal disappears on Sep 11 UTC onwards.
 */
const MFA_SHARED_LOGIN_NOTICE_EXPIRY = new Date('2026-09-11T00:00:00Z');

/** Returns true when the shared-login sunset notice should no longer be shown. */
export function isSharedLoginNoticePastDeadline(now = new Date()): boolean {
  return now >= MFA_SHARED_LOGIN_NOTICE_EXPIRY;
}
